














import Vue from 'vue'
import { Component } from 'vue-property-decorator'

@Component
export default class DropdownTransition extends Vue {

  enter(el) {
    el.style.height = 'auto'
    const height = getComputedStyle(el).height
    el.style.height = 0
    setTimeout(() => {
      el.style.height = height
    })
  }

  afterEnter(el) {
    el.style.height = 'auto'
  }

  leave(el) {
    const height = getComputedStyle(el).height
    el.style.height = height
    setTimeout(() => {
      el.style.height = 0
    })
  }
}
